// extracted by mini-css-extract-plugin
export default {"wrapper":"calculatorSection_wrapper__QItTX","content":"calculatorSection_content__0JMZB","title":"calculatorSection_title__ZfrgC","text":"calculatorSection_text__JULOv"};